import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onDblclick"]
const _hoisted_2 = {
  key: 0,
  class: "row q-mb-md count"
}
const _hoisted_3 = { class: "icon-container" }
const _hoisted_4 = { class: "subtitle q-mx-sm" }
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = {
  key: 1,
  class: "card-title"
}
const _hoisted_7 = { class: "category-chips" }
const _hoisted_8 = {
  key: 5,
  class: "label flex"
}
const _hoisted_9 = {
  class: "tooltip",
  style: {"position":"relative","top":"-4px"}
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "wrapper-trackingcode" }
const _hoisted_12 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "category-chips" }
const _hoisted_15 = {
  key: 8,
  class: "packaging-group"
}
const _hoisted_16 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "before-options" }
const _hoisted_19 = { class: "float-right" }
const _hoisted_20 = { class: "ellipsis" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "value flex" }
const _hoisted_25 = { class: "weight-row" }
const _hoisted_26 = { class: "row q-col-gutter-md q-mt-sm" }
const _hoisted_27 = { class: "col-3" }
const _hoisted_28 = { class: "col-3" }
const _hoisted_29 = { class: "col-3" }
const _hoisted_30 = {
  key: 0,
  class: "col-3"
}
const _hoisted_31 = {
  key: 1,
  class: "expandeded-stock-data"
}
const _hoisted_32 = { class: "meta-data" }
const _hoisted_33 = { class: "row q-mb-sm items-center" }
const _hoisted_34 = { class: "field q-mr-md" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = {
  key: 1,
  class: "row q-mb-md"
}
const _hoisted_37 = { class: "row q-mb-md" }
const _hoisted_38 = {
  key: 0,
  class: "read-more flex items-center"
}
const _hoisted_39 = {
  key: 1,
  class: "read-less flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_minus_circle_icon = _resolveComponent("minus-circle-icon")!
  const _component_plus_circle_icon = _resolveComponent("plus-circle-icon")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_barcode_icon = _resolveComponent("barcode-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_searchable_multi_select = _resolveComponent("searchable-multi-select")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_packing_table = _resolveComponent("packing-table")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_editable_block_dimension_input = _resolveComponent("editable-block-dimension-input")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_warehouse_information = _resolveComponent("warehouse-information")!
  const _component_property_information = _resolveComponent("property-information")!
  const _component_packing_group_modal = _resolveComponent("packing-group-modal")!
  const _component_editable_block = _resolveComponent("editable-block")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    "model-value": _ctx.component,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitUpdate(_ctx.component, _ctx.component?.sys?.id, $event))),
    editing: _ctx.editing,
    onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('cancel'))),
    "onUpdate:editing": _cache[8] || (_cache[8] = ($event: any) => {_ctx.$emit('update:editing', $event); _ctx.expanded = true}),
    "remove-block-style": "",
    "remove-scope-style": ""
  }, {
    default: _withCtx(({editState, editingRef}) => [
      _createElementVNode("div", {
        class: _normalizeClass(["collapsed-stock-data", {expanded: _ctx.expanded}]),
        onDblclick: ($event: any) => (editingRef.value = true)
      }, [
        (!editingRef.value)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              selector: ".collapsed-stock-data",
              "tooltip-value": "Double click to edit"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["fields-grid", { editing: editingRef.value }])
        }, [
          (editingRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, [
                  _createElementVNode("label", null, "Amount")
                ], -1)),
                _createElementVNode("div", _hoisted_3, [
                  (editState.count > 1)
                    ? (_openBlock(), _createBlock(_component_minus_circle_icon, {
                        key: 0,
                        onClick: ($event: any) => (editState.count -= 1)
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h6", _hoisted_4, _toDisplayString(editState.count), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_plus_circle_icon, {
                    onClick: ($event: any) => (editState.count += 1)
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!editingRef.value)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(`${editState.count}x ${editState.title}`), 1))
            : (_openBlock(), _createBlock(_component_editable_block_input, {
                key: 2,
                class: "styled-select",
                label: "Title",
                modelValue: editState.title,
                "onUpdate:modelValue": ($event: any) => ((editState.title) = $event),
                max: "255",
                error: !editState.title
              }, null, 8, ["modelValue", "onUpdate:modelValue", "error"])),
          _createVNode(_component_editable_block_input, {
            class: "styled-select",
            modelValue: editState.sku,
            "onUpdate:modelValue": ($event: any) => ((editState.sku) = $event),
            error: !editState.sku,
            tooltip: _ctx.tooltips.sku,
            label: "SKU",
            max: "64"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "tooltip"]),
          _createVNode(_component_editable_block_input, {
            "model-value": editState.ean,
            tooltip: _ctx.tooltips.ean,
            label: "EAN"
          }, {
            static: _withCtx(({ inputState }) => [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputState.value, (value) => {
                  return (_openBlock(), _createBlock(_component_q_chip, { class: "category-chip" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              (!_ctx.showBarcodeEan && _ctx.value)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "barcode-icon q-ml-sm",
                    flat: "",
                    round: "",
                    color: "primary",
                    padding: "1px",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBarcodeEan = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_barcode_icon)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.value && _ctx.showBarcodeEan)
                ? (_openBlock(), _createBlock(_component_barcode, {
                    key: 1,
                    class: _normalizeClass(["sku-datamatrix", { active: _ctx.showBarcodeEan }]),
                    "model-value": _ctx.value,
                    format: "datamatrixrectangular",
                    "bar-width": 15,
                    "bar-height": 3
                  }, null, 8, ["model-value", "class"]))
                : _createCommentVNode("", true)
            ]),
            input: _withCtx(({ inputState }) => [
              _createVNode(_component_form_select, {
                label: inputState.label,
                modelValue: inputState.value,
                "onUpdate:modelValue": ($event: any) => ((inputState.value) = $event),
                type: "tag",
                validator: e => !_ctx.validateEan(e) ? {value: false, message: 'Invalid EAN'} : _ctx.setEan(e, editState) ,
                taggable: true,
                placeholder: "Input EAN code(s)",
                onClipboard: _ctx.clipped
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "validator", "onClipboard"])
            ]),
            _: 2
          }, 1032, ["model-value", "tooltip"]),
          (!editingRef.value)
            ? (_openBlock(), _createBlock(_component_editable_block_input, {
                key: 3,
                class: "hs-code",
                "model-value": _ctx.getHS(editState.hs),
                "onUpdate:modelValue": ($event: any) => (_ctx.setHS(editState, $event)),
                label: "HS"
              }, null, 8, ["model-value", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          (editingRef.value)
            ? (_openBlock(), _createBlock(_component_q_select, {
                key: 4,
                class: "compact",
                modelValue: editState.hs,
                "onUpdate:modelValue": [($event: any) => ((editState.hs) = $event), ($event: any) => (_ctx.setHS(editState, $event))],
                options: _ctx.HSOptions,
                "input-debounce": "500",
                "use-input": "",
                dense: "",
                onFilter: _ctx.filterHSFn,
                label: "HS",
                clearable: "",
                "option-label": option => _ctx.getHS(option)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onFilter", "option-label"]))
            : _createCommentVNode("", true),
          (!editingRef.value && _ctx.tooltips.productHasTrackingCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_info_button),
                  _createVNode(_component_q_tooltip, {
                    anchor: "bottom left",
                    "max-width": "200"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: _ctx.tooltips.productHasTrackingCode
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (editingRef.value && _ctx.tooltips.productHasTrackingCode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_info_button),
                        _createVNode(_component_q_tooltip, {
                          anchor: "bottom left",
                          "max-width": "200"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              innerHTML: _ctx.tooltips.productHasTrackingCode
                            }, null, 8, _hoisted_13)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_checkbox, {
                    class: "check-trackingcode",
                    onClick: ($event: any) => (editingRef.value = true),
                    "model-value": editState.supply_chain_tracking ? true : false,
                    "onUpdate:modelValue": ($event: any) => (editState.supply_chain_tracking = $event),
                    label: "Product has tracking code",
                    size: "sm"
                  }, null, 8, ["onClick", "model-value", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "value" }, null, -1)),
          (editingRef.value)
            ? (_openBlock(), _createBlock(_component_searchable_multi_select, {
                key: 6,
                "model-value": editState.categories?.map(c => typeof c == 'object' ? c.sys?.id : c),
                "onUpdate:modelValue": e => _ctx.addCategory(editState, e),
                onCache: _ctx.updateCategories,
                "content-type": "category",
                label: "Categories",
                placeholder: "Select categories",
                query: e => [{field: 'label', method: 'like', match: e}, {field: 'name', method: 'like', match: e}, {field: 'type', method: 'is', match: 'product'}],
                handlers: _ctx.categoryHandlers,
                "match-any": "",
                createable: ""
              }, null, 8, ["model-value", "onUpdate:modelValue", "onCache", "query", "handlers"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "medium" }, "Categories", -1)),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editState.categories?.map(c => typeof c == 'object' ? c?.name : _ctx.categories.find(cat => cat.sys?.id === c)?.name), (category) => {
                    return (_openBlock(), _createBlock(_component_q_chip, { class: "category-chip" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ])
              ], 64)),
          (editingRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.tooltips.packagingGroup)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_info_button),
                      _createVNode(_component_q_tooltip, {
                        anchor: "bottom left",
                        "max-width": "200"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: _ctx.tooltips.packagingGroup
                          }, null, 8, _hoisted_17)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_select, {
                  modelValue: _ctx.selectedFormattedPacking,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFormattedPacking) = $event)),
                  options: _ctx.filteredFormattedPacking,
                  "popup-content-style": "padding: 0;",
                  onFilter: _ctx.filterFn,
                  label: "Packaging group",
                  "popup-content-class": "select packing-select",
                  "use-chips": "",
                  multiple: "",
                  "use-input": "",
                  dense: ""
                }, {
                  "before-options": _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives((_openBlock(), _createBlock(_component_d_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreatePackingGroup = true)),
                        flat: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_add_icon, { left: "" }),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Create packaging group", -1))
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ])
                  ]),
                  option: _withCtx((scope) => [
                    (_openBlock(), _createBlock(_component_q_item, _mergeProps({
                      key: scope.index
                    }, scope.itemProps), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(scope.label), 1),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(scope.opt.type), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040))
                  ]),
                  "selected-item": _withCtx((scope) => [
                    (_openBlock(), _createBlock(_component_q_chip, {
                      key: `option-${scope.index}`,
                      dense: "",
                      removable: "",
                      clickable: scope.opt.type === 'Packing Group',
                      onClick: _withModifiers(($event: any) => (_ctx.onPackingGroupClick(scope.opt)), ["stop","prevent"]),
                      onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(scope.opt.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["clickable", "onClick", "onRemove"]))
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "onFilter"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                _createElementVNode("div", _hoisted_21, [
                  (!editingRef.value && _ctx.tooltips.packagingGroup)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_info_button, { style: {"margin-bottom":"-23px"} }),
                        _createVNode(_component_q_tooltip, {
                          anchor: "bottom left",
                          "max-width": "200"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              innerHTML: _ctx.tooltips.packagingGroup
                            }, null, 8, _hoisted_23)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "medium" }, "Packaging (-groups)", -1))
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_packing_table, {
                    packing: editState.packing
                  }, null, 8, ["packing"])
                ])
              ], 64)),
          _createVNode(_component_editable_block_input, {
            class: "styled-select",
            label: "Brand",
            modelValue: editState.brand,
            "onUpdate:modelValue": ($event: any) => ((editState.brand) = $event),
            max: "64"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_editable_block_input, {
            class: "styled-select",
            label: "Producer",
            modelValue: editState.producer,
            "onUpdate:modelValue": ($event: any) => ((editState.producer) = $event),
            max: "64"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_editable_block_input, {
            class: "styled-select",
            label: "Batch",
            modelValue: editState.batch,
            "onUpdate:modelValue": ($event: any) => ((editState.batch) = $event),
            type: "number",
            min: 0,
            tooltip: _ctx.tooltips.batch
          }, null, 8, ["modelValue", "onUpdate:modelValue", "tooltip"]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_editable_block_dimension_input, {
              modelValue: editState.weight,
              "onUpdate:modelValue": ($event: any) => ((editState.weight) = $event),
              append: editState?.dimensions?.weight_unit || 'g',
              pattern: "d",
              min: 0,
              label: "Weight"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "scale" })
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "append"]),
            (editingRef.value)
              ? (_openBlock(), _createBlock(_component_form_select, {
                  key: 0,
                  class: "styled-select weight-unit-select centered-header",
                  "model-value": editState.dimensions.weight_unit,
                  "onUpdate:modelValue": ($event: any) => ((editState.dimensions.weight_unit) = $event),
                  placeholder: editState.dimensions.weight_unit ? editState.dimensions.weight_unit : 'g',
                  options: _ctx.weightUnits,
                  type: "select",
                  borderless: ""
                }, null, 8, ["model-value", "onUpdate:modelValue", "placeholder", "options"]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_editable_block_dimension_input, {
              modelValue: editState.dimensions.x,
              "onUpdate:modelValue": ($event: any) => ((editState.dimensions.x) = $event),
              append: editState.dimensions.unit ? editState.dimensions.unit : 'cm',
              dimension: "length",
              label: "L"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "append"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_editable_block_dimension_input, {
              modelValue: editState.dimensions.y,
              "onUpdate:modelValue": ($event: any) => ((editState.dimensions.y) = $event),
              append: editState.dimensions.unit ? editState.dimensions.unit : 'cm',
              dimension: "width",
              label: "W"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "append"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_editable_block_dimension_input, {
              modelValue: editState.dimensions.z,
              "onUpdate:modelValue": ($event: any) => ((editState.dimensions.z) = $event),
              append: editState.dimensions.unit ? editState.dimensions.unit : 'cm',
              dimension: "height",
              label: "H"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "append"])
          ]),
          (editingRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(_component_form_select, {
                  class: "styled-select centered-header",
                  "model-value": editState.dimensions.unit,
                  "onUpdate:modelValue": ($event: any) => ((editState.dimensions.unit) = $event),
                  placeholder: editState.dimensions.unit ? editState.dimensions.unit : 'cm',
                  options: _ctx.units,
                  type: "select",
                  borderless: ""
                }, null, 8, ["model-value", "onUpdate:modelValue", "placeholder", "options"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.expanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "divider meta" }, null, -1)),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row q-mb-sm" }, [
                  _createElementVNode("h5", { class: "card-title" }, "Meta fields")
                ], -1)),
                (editState.meta)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(editState.meta, (value, key, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_editable_block_input, {
                            class: "styled-select",
                            "model-value": key,
                            "onUpdate:modelValue": ($event: any) => (_ctx.updateKey(index, $event, editState)),
                            label: "Field"
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_editable_block_input, {
                            class: "styled-select",
                            "model-value": value,
                            "onUpdate:modelValue": ($event: any) => (_ctx.updateValue(key, $event, editState)),
                            label: "Value"
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        (editingRef.value)
                          ? (_openBlock(), _createBlock(_component_TrashIcon, {
                              key: 0,
                              class: "q-ml-sm remove",
                              onClick: ($event: any) => (_ctx.removeMetaField(index, editState)),
                              size: "16px"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[14] || (_cache[14] = [
                      _createElementVNode("h6", { class: "subtitle" }, "No meta fields found", -1)
                    ]))),
                _createElementVNode("div", _hoisted_37, [
                  (editingRef.value)
                    ? (_openBlock(), _createBlock(_component_d_button, {
                        key: 0,
                        onClick: ($event: any) => (_ctx.addMetaField(editState)),
                        flat: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_add_icon, { left: "" }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Meta field", -1))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_warehouse_information, {
                "component-id": _ctx.component.sys.id
              }, null, 8, ["component-id"]),
              _createVNode(_component_property_information, {
                editing: editingRef.value,
                props: editState.props,
                "onUpdate:props": ($event: any) => ((editState.props) = $event),
                "all-props": _ctx.allProps,
                "new-props": _ctx.newProps,
                "onUpdate:newProps": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newProps) = $event)),
                "prop-values": _ctx.propValues
              }, null, 8, ["editing", "props", "onUpdate:props", "all-props", "new-props", "prop-values"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "expand",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
        }, [
          (!_ctx.expanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_component_d_button, { flat: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      left: "",
                      name: "expand_more"
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "Show more", -1))
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_d_button, { flat: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      left: "",
                      name: "expand_less"
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "Hide", -1))
                  ]),
                  _: 1
                })
              ]))
        ])
      ], 42, _hoisted_1),
      _createVNode(_component_packing_group_modal, {
        "show-create-packing-group": _ctx.showCreatePackingGroup,
        "category-id": _ctx.modalPackingCategoryId,
        onClose: _cache[5] || (_cache[5] = ($event: any) => {_ctx.showCreatePackingGroup = false; _ctx.modalPackingCategoryId = null}),
        onSave: ($event: any) => (_ctx.onPackingGroupSave($event, editState))
      }, null, 8, ["show-create-packing-group", "category-id", "onSave"])
    ]),
    _: 1
  }, 8, ["model-value", "editing"]))
}